<template>
    <div class="qrcode-wrap" :class="{ display: showQrcode, hide: !showQrcode }">
        <div
            class="column px-xxl py-xl pt-xxl center v-center text-center"
            style="position:absolute; top:50%; left:50%; transform: translate(-50%, -50%); z-index:99; background:#fff;"
        >
            <div style="width:160px; height:160px;">
                <img :src="QRCode" />
            </div>
            <div class="t5 black mt-xl">
                扫描二维码，<br />
                关注灵鹿科技微信公众号
            </div>
            <div class="column center v-center" style="width:240px; margin:0 auto;">
                <button class="btn btn-xxl primary mt-xl" type="button" @click="toggleQrcode">
                    确定
                </button>
            </div>
        </div>
        <div class="qrcode-mask" @click="toggleQrcode"></div>
    </div>
</template>

<script>
import { QRCode } from '@/constants/pics';

export default {
    name: 'qrcode',

    props: ['showQrcode', 'toggleQrcode'],

    components: {},

    data() {
        return {
            QRCode,
            // showQrcode: false,
        };
    },

    computed: {},

    created() {},

    mounted() {},

    activated() {},

    deactivated() {},

    methods: {
        // toggleQrcode() {
        //     this.showQrcode = !this.showQrcode;
        // },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.qrcode-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
}
.qrcode-wrap.display {
    display: block;
}
.qrcode-wrap.hide {
    display: none;
}

.qrcode-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.62);
    z-index: 98;
}
</style>
